import { useTranslation } from "react-i18next";

interface HeaderTitleProps {
  title: string; // Pass a i18n reference key as prop
}

export const HeaderTitle = ({ title }: HeaderTitleProps) => {
  const { t } = useTranslation();

  return <p>{t(`${title}`)}</p>;
};
